import { usePagination } from '@/common/hooks/usePagination';
import { useScrollTopOnChange } from '@/common/hooks/useScrollTopOnChange';
import DEFAULT_OPERATIONS from '@/hooks/SearchPage/searchPage.gql';
import mergeOperations from '@/util/shallowMerge';
import { useQuery } from '@apollo/client';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

export const useGetSearchData = ({
  pageSize,
  sortDirection,
  sortAttribute,
  newFilters,
}: {
  pageSize: string | number;
  sortDirection: any;
  sortAttribute: any;
  newFilters: any;
}) => {
  const operations = mergeOperations(DEFAULT_OPERATIONS);
  const { productSearchQuery } = operations;

  const [paginationValues, paginationApi] = usePagination();
  const { setCurrentPage, setTotalPages } = paginationApi as any;
  const { currentPage, totalPages } = paginationValues as any;

  const searchParams = useSearchParams();

  const inputText = searchParams.get('query');

  const {
    called: searchCalled,
    loading: searchLoading,
    error,
    data,
  } = useQuery(productSearchQuery, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      currentPage: Number(currentPage),
      filters: newFilters,
      inputText,
      pageSize: Number(pageSize),
      sort:
        inputText !== ''
          ? {
              relevance: 'DESC',
            }
          : {
              [sortAttribute]: sortDirection,
            },
    },
    onCompleted: async data => {
      // const currentIp = await fetchClientIp();
      // try {
      //   const { products } = data || {};
      //   await fetch('/api/pinterest-search', {
      //     method: 'POST',
      //     body: JSON.stringify({
      //       searchTerm: inputText,
      //       products: products?.items, // Array of products returned from search
      //       ip: currentIp,
      //     }),
      //   });
      // } catch (error) {
      //   console.error('Error in onCompleted', error);
      // }
    },
  });

  const pageControl = {
    currentPage,
    setPage: setCurrentPage,
    totalPages,
  };

  useScrollTopOnChange(currentPage);

  // Set the total number of pages whenever the data changes.
  useEffect(() => {
    const totalPagesFromData = data ? data.products.page_info.total_pages : null;

    setTotalPages(totalPagesFromData);

    return () => {
      setTotalPages(null);
    };
  }, [data, setTotalPages]);

  return {
    searchCalled,
    searchLoading,
    error,
    data,
    pageControl,
  };
};
